import { Instance, Objekt, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { resources } from '../resources';
import { AdminSponsorService } from '../services/adminSponsorService';
import { LanguageService } from '../services/languageService';
import { AdminController } from './adminController';

export class AdminSponsorsIndexController extends AdminController {
    private table: Table;

    constructor(
        instances: Instance,
        private adminSponsorService: AdminSponsorService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton(
            '.btn-admin-index',
            this.dom,
            () => {
                this.state.goBack('admin.index');
            },
            '',
            true,
            [],
        );

        this.helper.iconButton('.btn-sponsors-new', this.dom, () => {
            this.adminSponsorService.newDialogByAdmin().then(() => {
                this._drawContent();
            });
        });
    }

    protected override _initTable(): void {
        if (!this.table) {
            this.table = new Table(
                this.dom,
                'table',
                this.adminSponsorService.getTableOptions(),
            );

            this.table.setActions([
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (sponsor) => {
                        this.adminSponsorService
                            .editDialog(sponsor, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ]);

            this.table.eventAction = (params) => {
                params.set('query', this.query);
                params.set('fields', this.adminSponsorService.getTableFields());
                this.adminSponsorService.getAll(params).then((response) => {
                    const count = response.get<number>('count');
                    this.table.setCount(count);
                    const sponsors = response.get<Objekt[]>('sponsors');
                    this.table.setData(sponsors);
                });
            };

            this.table.render();
        } else {
            this.table.refresh();
        }
    }
}

export const adminSponsorsIndexController = app.controller(
    resources.adminSponsorsIndexController,
    [
        resources.instances,
        resources.adminSponsorService,
        resources.languageService,
    ],
    AdminSponsorsIndexController,
);
